export const DEFAULT_INVENTORY_PUSH_MINIMUM_QUANTITY = 1;

export interface InventoryPushSettings {
  inventoryPushMinimumQuantity?: number | null;
}

export function getInventoryPushMinimumQuantity(
  settings: InventoryPushSettings | null | undefined,
): number {
  const minimumQuantity = settings?.inventoryPushMinimumQuantity;
  if (
    minimumQuantity == null ||
    !Number.isFinite(minimumQuantity) ||
    minimumQuantity < 0
  ) {
    return DEFAULT_INVENTORY_PUSH_MINIMUM_QUANTITY;
  }
  return Math.floor(minimumQuantity);
}

export function getInventoryPushQuantity({
  sourceQuantity,
  settings,
}: {
  sourceQuantity: bigint | number;
  settings: InventoryPushSettings | null | undefined;
}): number {
  const quantity = Math.max(0, Number(sourceQuantity));
  const minimumQuantity = getInventoryPushMinimumQuantity(settings);
  return quantity >= minimumQuantity ? quantity : 0;
}

export function shouldPushAdditiveInventoryRestock({
  sourceQuantity,
  settings,
}: {
  sourceQuantity: bigint | number;
  settings: InventoryPushSettings | null | undefined;
}): boolean {
  const quantity = Math.max(0, Number(sourceQuantity));
  const minimumQuantity = getInventoryPushMinimumQuantity(settings);
  return quantity >= minimumQuantity;
}
